<div
  class="fixed inset-0 z-50 flex items-center justify-center"
  [class.pointer-events-none]="!isModalOpen"
>
  <!-- Backdrop -->
  <div
    class="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ease-out"
    [class.opacity-0]="!isModalOpen"
    (click)="onBackdropClick()"
  ></div>

  <!-- Modal Content -->
  <div
    class="relative z-20 px-4 flex justify-center items-center w-full transition-all duration-300 ease-out transform"
    [class.opacity-0]="!isModalOpen"
    [class.scale-95]="!isModalOpen"
  >
    <ng-template #modalHost></ng-template>
  </div>
</div>
